// 最近閲覧した商品を保存
function saveRecentlyViewedProduct(productId) {
  try {
    let recentlyViewedProducts = JSON.parse(
      localStorage.getItem("theme:recently-viewed-products") || "[]"
    );
    recentlyViewedProducts = recentlyViewedProducts.filter(
      item => item !== productId
    );
    recentlyViewedProducts.unshift(productId);
    localStorage.setItem(
      "theme:recently-viewed-products",
      JSON.stringify(recentlyViewedProducts)
    );
  } catch {
    // Safari in private mode does not allow setting item, we silently fail
  }
}

// グローバル変数: パフォーマンス最適化用
let cachedProductType = null;
const cachedDOMElements = {};

// DOM要素キャッシュ関数
function getCachedElement(selector, key) {
  if (!cachedDOMElements[key]) {
    cachedDOMElements[key] = document.querySelector(selector);
  }
  return cachedDOMElements[key];
}

// 商品タグチェック関数（1本追加購入判定用）
function hasAdditionalPurchaseTag() {
  const selectors = [
    "form[data-product-tags]",
    "[data-product-tags]",
    ".product-form [data-product-tags]",
    ".option-block [data-product-tags]",
  ];

  for (const selector of selectors) {
    const element = document.querySelector(selector);
    if (element) {
      const tags = element.getAttribute("data-product-tags") || "";

      if (tags.includes("1本追加購入")) {
        return true;
      }
    }
  }

  return false;
}

// data属性ベースのプロパティ要素取得関数
function getPropertyElement(propertyType) {
  return document.querySelector(`[data-property-type="${propertyType}"]`);
}

// data属性ベースのプロパティ値取得関数
function getPropertyValue(propertyType) {
  const element = getPropertyElement(propertyType);
  if (!element) return null;

  // radio/checkboxの場合は選択されている要素から値を取得
  if (element.type === "radio" || element.type === "checkbox") {
    const checked = document.querySelector(
      `[data-property-type="${propertyType}"]:checked`
    );
    return checked ? checked.value : null;
  }

  return element.value;
}

// チェック済みのプロパティ要素を取得
function getPropertyElementChecked(propertyType) {
  return document.querySelector(
    `[data-property-type="${propertyType}"]:checked`
  );
}

// data属性からVariant IDを取得
function getPropertyVariantId(propertyType) {
  const element = getPropertyElement(propertyType);
  if (!element) return null;

  // select要素の場合は選択されたoptionから取得
  if (element.tagName === "SELECT") {
    const selectedOption = element.options[element.selectedIndex];
    return selectedOption?.dataset.variantId || null;
  }

  // radio/checkboxの場合はチェックされた要素から取得
  if (element.type === "radio" || element.type === "checkbox") {
    const checked = getPropertyElementChecked(propertyType);
    return checked?.dataset.variantId || null;
  }

  // その他の要素の場合は直接取得
  return element.dataset.variantId || null;
}

// window.i18nを利用したシンプルなプロパティキー取得
function getPropertyKey(type) {
  switch (type) {
    case "applicable_product":
      return window.i18n?.properties?.applicable_product || "適用される商品";
    case "target_location":
      return window.i18n?.properties?.target_location || "該当箇所と爪のサイズ";
    case "shortening":
      return window.i18n?.properties?.shortening || "短くする加工";
    default:
      return type;
  }
}

// 場所名の翻訳関数
function getLocalizedLocationName(japaneseLocation) {
  const lang = document.documentElement.lang || "ja";
  if (lang === "ja") return japaneseLocation;

  // 短くする加工専用の翻訳マッピング
  const shorteningLocationMap = {
    "親(右)": "Thumb(R)",
    "人(右)": "Index(R)",
    "中(右)": "Middle(R)",
    "薬(右)": "Ring(R)",
    "小(右)": "Pinky(R)",
    "親(左)": "Thumb(L)",
    "人(左)": "Index(L)",
    "中(左)": "Middle(L)",
    "薬(左)": "Ring(L)",
    "小(左)": "Pinky(L)",
  };

  return shorteningLocationMap[japaneseLocation] || japaneseLocation;
}

// エラー通知システム
function showUserError(message, options = {}) {
  const { isFootNail = false, duration = 3000, type = "error" } = options;

  // 既存のエラー通知を削除
  const existingErrors = document.querySelectorAll(".error-notification");
  existingErrors.forEach(error => error.remove());

  // エラー要素を作成
  const errorContainer = document.createElement("div");
  errorContainer.className = `error-notification error-notification--${type}`;
  if (isFootNail) {
    errorContainer.classList.add("error-notification--foot-nail");
  }

  errorContainer.innerHTML = `
    <span class="error-notification__message">${message}</span>
    <button class="error-notification__close" aria-label="Close">×</button>
  `;

  // インラインスタイルを追加（CSSファイルがない場合のフォールバック）
  errorContainer.style.cssText = `
    position: relative;
    background: #ff4444;
    color: white;
    padding: 12px 16px;
    border-radius: 4px;
    margin: 8px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    z-index: 1000;
    animation: slideIn 0.3s ease-out;
  `;

  // 閉じるボタンのスタイル
  const closeButtonStyle = `
    background: none;
    border: none;
    color: white;
    font-size: 18px;
    cursor: pointer;
    padding: 0;
    margin-left: 12px;
    opacity: 0.8;
    transition: opacity 0.2s;
  `;

  // アニメーション用のキーフレームを追加（一度だけ）
  if (!document.getElementById("error-notification-styles")) {
    const style = document.createElement("style");
    style.id = "error-notification-styles";
    style.textContent = `
      @keyframes slideIn {
        from { opacity: 0; transform: translateY(-10px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .error-notification__close:hover {
        opacity: 1 !important;
      }
      .error-notification--validation {
        background: #ff8800 !important;
      }
      .error-notification--network {
        background: #cc0000 !important;
      }
      .error-notification--foot-nail {
        border-left: 4px solid #ffffff !important;
      }
    `;
    document.head.appendChild(style);
  }

  // 表示位置を決定
  let targetContainer;
  if (isFootNail) {
    targetContainer =
      document.querySelector(".c-foot-selector") ||
      document.querySelector("#cart-popup .popup-wrap") ||
      document.body;
  } else {
    targetContainer =
      document.querySelector("#cart-popup .popup-wrap") ||
      document.querySelector(".product-form") ||
      document.body;
  }

  targetContainer.appendChild(errorContainer);

  // 閉じるボタンのイベント
  const closeButton = errorContainer.querySelector(
    ".error-notification__close"
  );
  closeButton.style.cssText = closeButtonStyle;
  closeButton.addEventListener("click", () => {
    errorContainer.remove();
  });

  // 自動削除タイマー
  if (duration > 0) {
    setTimeout(() => {
      if (errorContainer.parentNode) {
        errorContainer.remove();
      }
    }, duration);
  }

  // フォーカス管理
  errorContainer.setAttribute("role", "alert");
  errorContainer.setAttribute("aria-live", "polite");
}

// フットネイル特有のバリデーション
function validateFootNailInputs() {
  // 新しいフォーム構造に対応した検証
  // relevant-part セレクターを使用してサイズ選択要素を取得
  const sizeSelects = document.querySelectorAll('select[id*="relevant-part"]');

  if (sizeSelects.length === 0) {
    // フォールバック: 古いセレクターを試行
    const sizeInput = document.querySelector(
      '[data-property-type="size"]:checked'
    );
    if (!sizeInput) {
      throw new Error(
        window.i18n?.errors?.selectSize || "※サイズを選択してください"
      );
    }
    return;
  }

  // 新しいフォーム構造: 少なくとも1つのサイズが選択されているかチェック
  const hasSelectedSize = Array.from(sizeSelects).some(select => {
    const value = select.value;
    const isSelected = value && value !== "" && value !== "✕";
    return isSelected;
  });

  if (!hasSelectedSize) {
    throw new Error(
      window.i18n?.errors?.selectSize || "※サイズを選択してください"
    );
  }
}

// カートポップアップ
function cartPopup(e) {
  e.preventDefault();
  const cartPopupEl = getCachedElement("#cart-popup", "cartPopup");
  cartPopupEl.classList.toggle("open");
  if (cartPopupEl.classList.contains("open")) {
    e.target.innerText = window.i18n.ui.cancel;
    e.target.style.background = "#fff";
    e.target.style.color = "#333";
    document.querySelector(".buy-buttons.submit").style.display = "block";
    document.getElementById("main").style.position = "fixed";
    document.getElementsByTagName("header")[0].style.position = "static";
    document
      .getElementsByTagName("product-sticky-bar")[0]
      .classList.toggle("menu-opened");
    submitChecked();
    requiredCheck();
    checkProductRequirements();
  } else {
    e.target.innerText = window.i18n.ui.addToCart;
    e.target.style.background = "#333";
    e.target.style.color = "#fff";
    document.querySelector(".buy-buttons.submit").style.display = "none";
    document.getElementById("main").style.position = "";
    document.getElementsByTagName("header")[0].style.position = "";
    document
      .getElementsByTagName("product-sticky-bar")[0]
      .classList.toggle("menu-opened");
  }
}

// フィールド名を取得する関数（data属性優先、多言語対応、フォールバック付き）
function getFieldName(element) {
  const label = document.querySelector(`label[for="${element.id}"]`);
  const container = element.closest("[data-field-name]");

  // 0. data-property-key属性から取得（最優先 - すでにローカライズ済み）
  if (element.dataset.propertyKey) {
    return element.dataset.propertyKey;
  }

  // 1. container要素のdata-field-name属性から取得（多言語対応）
  if (container && container.dataset.fieldName) {
    const fieldKey = container.dataset.fieldName;
    if (window.i18n?.labels?.[fieldKey]) {
      return window.i18n.labels[fieldKey];
    }

    // フォールバック: 翻訳キーを使った統一的なマッピング
    const fieldMappings = {
      orderNumber: window.i18n?.fieldNames?.orderNumber || "注文番号",
      customerName: window.i18n?.fieldNames?.customerName || "お名前",
      targetProduct: window.i18n?.fieldNames?.targetProduct || "対象商品",
      targetPartAndSize:
        window.i18n?.fieldNames?.targetPartAndSize || "対象箇所・ネイルサイズ",
      size: window.i18n?.fieldNames?.size || "サイズ",
      chipShape: window.i18n?.fieldNames?.chipShape || "チップの形",
      design: window.i18n?.fieldNames?.design || "デザイン",
      length: window.i18n?.fieldNames?.length || "長さ",
      handType: window.i18n?.fieldNames?.handType || "手の種類",
      targetLocation: window.i18n?.fieldNames?.targetLocation || "対象箇所",
    };

    if (fieldMappings[fieldKey]) {
      return fieldMappings[fieldKey];
    }

    // 最終フォールバック: data-field-name属性の値をそのまま使用
    return fieldKey;
  }

  // 2. label要素のdata-field-name属性から取得（多言語対応）
  if (label && label.dataset.fieldName) {
    const fieldKey = label.dataset.fieldName;
    if (window.i18n?.labels?.[fieldKey]) {
      return window.i18n.labels[fieldKey];
    }
    return label.dataset.fieldName;
  }

  // 3. フォールバック: innerTextから取得（括弧前まで）
  return label ? label.innerText.split("（")[0] : element.name || element.id;
}

// バリデーションメッセージをフォーマットする関数
function formatValidationMessage(fieldNames) {
  const template =
    window.i18n?.validation?.requiredFieldsTemplate ||
    "※{fields}を入力してください。";
  const fields = fieldNames.join(", "); // 統一セパレーター使用
  return template.replace("{fields}", fields);
}

// 「利用しない」を判定する共通関数（多言語対応）
function isNotUseValue(value) {
  // 翻訳キーが存在する場合でもincludesチェックを使用
  if (window.i18n?.options?.notUse) {
    return value.includes(window.i18n.options.notUse);
  }

  // フォールバック：従来の文字列判定
  return (
    value.includes("利用しない") ||
    value.includes("not use") ||
    value.includes("Not use")
  );
}

// 旧関数は統一バリデーション関数（validateAllRequiredFields）に置換済み

// 通知が空の時にカートボタンを有効化する関数
function checkAndEnableCartButton() {
  const cartButtonNotice = getCachedElement(
    "#cart-button-notice",
    "cartButtonNotice"
  );
  const cartButtonRelevantPartNotice = document.getElementById(
    "cart-button-relevant-part-notice"
  );
  const cartBtn = document.querySelector(".buy-buttons.submit button");

  if (cartBtn) {
    // 両方の通知が空の場合、ボタンを有効化
    if (
      (!cartButtonNotice || cartButtonNotice.innerText === "") &&
      (!cartButtonRelevantPartNotice ||
        cartButtonRelevantPartNotice.innerText === "")
    ) {
      cartBtn.disabled = false;
    }
  }
}

function submitChecked() {
  // カートに入れる確定ボタンの制御
  document
    .getElementById("before_submit_check")
    .addEventListener("change", e => {
      if (
        e.target.checked === true &&
        getCachedElement("#cart-button-notice", "cartButtonNotice")
          .innerText === ""
      ) {
        document
          .querySelector(".buy-buttons.submit")
          .classList.remove("disabled");
      } else {
        document.querySelector(".buy-buttons.submit").classList.add("disabled");
      }
    });
}

// 統一バリデーション関数を使用した必須項目チェックと表示更新
function checkProductRequirements() {
  // cart-popupが存在しない場合は処理しない
  if (!document.getElementById("cart-popup")) {
    return;
  }

  // 統一バリデーション関数を使用（全商品対応）
  const invalidFields = validateAllRequiredFields();

  // 追加購入商品の場合の特別処理
  if (document.querySelector(".buy-one-addtional")) {
    const relevantPartNotice = document.getElementById(
      "cart-button-relevant-part-notice"
    );
    const noticeNode = getCachedElement(
      "#cart-button-notice",
      "cartButtonNotice"
    );

    if (invalidFields.length === 0) {
      // 全て有効な場合、両方のメッセージをクリア
      if (relevantPartNotice) {
        relevantPartNotice.innerText = "";
      }
      if (noticeNode) {
        noticeNode.innerText = "";
        noticeNode.dataset.selectedCheck = "true";
      }

      // ボタン有効化処理を追加
      const submitButtonContainer = document.querySelector(
        ".buy-buttons.submit"
      );
      const submitButton = submitButtonContainer?.querySelector("button");
      if (submitButtonContainer && submitButton) {
        submitButtonContainer.classList.remove("disabled");
        submitButton.disabled = false; // disabled属性も削除
      }
    } else {
      // 無効なフィールドがある場合、統一されたメッセージを表示
      if (noticeNode) {
        noticeNode.innerText = formatValidationMessage(invalidFields);
        noticeNode.dataset.selectedCheck = "";
      }
      // cart-button-relevant-part-noticeは使用しない
      if (relevantPartNotice) {
        relevantPartNotice.innerText = "";
      }
      // ボタン無効化処理を追加
      const submitButtonContainer = document.querySelector(
        ".buy-buttons.submit"
      );
      const submitButton = submitButtonContainer?.querySelector("button");
      if (submitButtonContainer && submitButton) {
        submitButtonContainer.classList.add("disabled");
        submitButton.disabled = true;
      }
    }
  } else {
    // 通常商品の場合
    const noticeNode = getCachedElement(
      "#cart-button-notice",
      "cartButtonNotice"
    );

    // メッセージとボタンの状態を更新
    if (invalidFields.length === 0) {
      noticeNode.innerText = "";
      noticeNode.dataset.selectedCheck = "true";

      const submitButtonContainer = document.querySelector(
        ".buy-buttons.submit"
      );
      const submitButton = submitButtonContainer?.querySelector("button");
      if (submitButtonContainer && submitButton) {
        submitButtonContainer.classList.remove("disabled");
        submitButton.disabled = false; // disabled属性も削除
      }
    } else {
      noticeNode.innerText = formatValidationMessage(invalidFields);
      noticeNode.dataset.selectedCheck = "";
      // ボタン無効化処理を追加
      const submitButtonContainer = document.querySelector(
        ".buy-buttons.submit"
      );
      const submitButton = submitButtonContainer?.querySelector("button");
      if (submitButtonContainer && submitButton) {
        submitButtonContainer.classList.add("disabled");
        submitButton.disabled = true;
      }
    }
  }

  // フットネイル特有の処理（サイズを選択して注文の場合）
  const selectedSizeType = document.querySelector(
    `.cart-popup input[data-property-type="size"]:checked`
  )?.value;

  if (selectedSizeType === window.i18n?.sizeTypes?.selectSizeToOrder) {
    checkSelectedStatus();
  }
}

function requiredCheck() {
  // cart-popupが存在しない場合は処理しない
  if (!document.getElementById("cart-popup")) {
    return;
  }

  checkProductRequirements();

  // 全ての必須フィールドに統一イベントリスナーを設定（全商品対応）
  const requiredFields = document.querySelectorAll(
    '[data-required-field="true"]'
  );

  requiredFields.forEach(field => {
    const inputs = field.querySelectorAll(
      'input[type="radio"], input[type="checkbox"], select, input[type="text"]'
    );

    inputs.forEach(input => {
      input.addEventListener("change", () => {
        // フットネイル特有処理: サイズを選択して注文の場合
        if (
          input.dataset.propertyType === "size" &&
          input.value === window.i18n?.sizeTypes?.selectSizeToOrder
        ) {
          // 修正: 実際のフォーム要素を検索
          let allSelects = document.querySelectorAll(
            ".c-foot-selector__item .c-foot-selector__select"
          );

          // 新しいフォーム構造の場合: relevant-part セレクターを使用
          if (allSelects.length === 0) {
            allSelects = document.querySelectorAll(
              'select[id*="relevant-part"]'
            );
          }

          allSelects.forEach(s => {
            s.removeEventListener("change", checkSelectedStatus);
            s.addEventListener("change", checkSelectedStatus);
          });
        }

        checkProductRequirements();
      });
    });
  });
}

// 統一バリデーション関数: 個別フィールドの検証
function isFieldValid(element) {
  const validationType = element.dataset.validationType;

  switch (validationType) {
    case "radio-group":
      return element.querySelectorAll('input[type="radio"]:checked').length > 0;
    case "checkbox-group":
      return (
        element.querySelectorAll('input[type="checkbox"]:checked').length > 0
      );
    case "select":
      const selects = element.querySelectorAll("select");
      return Array.from(selects).some(
        select => select.value !== "" && select.value !== "✕"
      );
    case "input":
      const input = element.querySelector("input");
      return input && input.value.trim() !== "";
    default:
      // デフォルトはradio-groupとして扱う
      return element.querySelectorAll('input[type="radio"]:checked').length > 0;
  }
}

// 統一バリデーション関数: 全必須フィールドの検証
function validateAllRequiredFields() {
  const requiredFields = document.querySelectorAll(
    '[data-required-field="true"]'
  );
  const invalidFields = [];
  const productType = getProductType();

  requiredFields.forEach(field => {
    const fieldName = field.dataset.fieldName;

    // フットネイル特有の条件: サイズフィールドの特別処理
    if (fieldName === "size" && productType === "foot-nail") {
      const sizeInput = document.querySelector(
        '[data-property-type="size"]:checked'
      );
      if (sizeInput) {

        // TODO: 名前で一致をみているので特定要素に必須の入力状態を管理するに変更
        // 「マイサイズを更新して注文」の場合でも、実際にサイズが選択されているかをチェック
        const checkedSizeElement = document.querySelector(
          '[data-property-type="size"]:checked'
        );
        if (
          checkedSizeElement &&
          (checkedSizeElement.dataset.sizeMode === "my-size" ||
            checkedSizeElement.id === "tip_size_mysize")
        ) {
          // フットネイル用のサイズ選択状態をチェック
          const hasSelectedSizes = checkFootNailSizeSelection();
          const selectorTitle = field.querySelector(".js-selector-title");

          if (hasSelectedSizes) {
            // サイズが選択されている場合は有効として扱う
            if (selectorTitle) {
              selectorTitle.classList.remove("not_selected");
            }
            return; // このフィールドはスキップ
          } else {
            // サイズが未選択の場合はエラー状態にする
            if (selectorTitle) {
              selectorTitle.classList.add("not_selected");
            }
            // 続行してバリデーションエラーを表示
          }
        }
      }
    }

    if (!isFieldValid(field)) {
      const fieldDisplayName = getFieldName(field);
      // 重複と空の値を排除
      if (
        fieldDisplayName &&
        fieldDisplayName.trim() &&
        !invalidFields.includes(fieldDisplayName)
      ) {
        invalidFields.push(fieldDisplayName);
      }

      // UI状態の更新
      const selectorTitle = field.querySelector(".js-selector-title");
      if (selectorTitle) {
        selectorTitle.classList.add("not_selected");
      }
    } else {
      // 有効な場合のUI状態更新
      const selectorTitle = field.querySelector(".js-selector-title");
      if (selectorTitle) {
        selectorTitle.classList.remove("not_selected");
      }
    }
  });

  return invalidFields;
}

// アドオンラベル更新機能
function initAddonLabelUpdates() {
  const addonControls = document.querySelectorAll("[data-addon-control]");

  addonControls.forEach(control => {
    control.addEventListener("change", updateAddonLabel);
    control.addEventListener("change", updateBuyButtonsVisibility);
  });

  // 初期状態でラベルを更新
  updateAllAddonLabels();
}

function updateAddonLabel(event) {
  const control = event.target;
  const addonId = control.dataset.addonId;
  updateAddonLabelForId(addonId);
}

function updateAddonLabelForId(addonId) {
  const legendElement = document.querySelector(
    `[data-addon-legend="${addonId}"]`
  );
  const containerElement = document.querySelector(
    `[data-addon-ui-id="${addonId}"]`
  );
  if (!legendElement || !containerElement) return;

  const selectedControl = document.querySelector(
    `[data-addon-control][data-addon-id="${addonId}"]:checked`
  );
  if (!selectedControl) return;

  const labelNone = containerElement.dataset.labelNone;
  const labelWith = containerElement.dataset.labelWith;

  if (selectedControl.value === "none") {
    legendElement.textContent = labelNone;
  } else if (selectedControl.value === "with") {
    legendElement.textContent = labelWith;
  }
}

function updateAllAddonLabels() {
  const addonIds = [
    ...new Set(
      Array.from(document.querySelectorAll("[data-addon-control]")).map(
        el => el.dataset.addonId
      )
    ),
  ];
  addonIds.forEach(addonId => updateAddonLabelForId(addonId));
}

function updateAddonAvailability(selectedVariant) {
  const addonContainers = document.querySelectorAll("[data-addon-ui-id]");

  if (addonContainers.length === 0) {
    return;
  }

  addonContainers.forEach(container => {
    const addonId = container.dataset.addonUiId;
    const isMainVariantAvailable = selectedVariant && selectedVariant.available;
    const isAddonAvailable = container.dataset.addonAvailable === "true";

    updateAddonControlsState(addonId, isMainVariantAvailable, isAddonAvailable);
  });

  if (document.querySelector(".shopify-payment-button")) {
    setTimeout(updateBuyButtonsVisibility, 100);
  }
}

function updateAddonControlsState(addonId, isMainAvailable, isAddonAvailable) {
  const shouldDisable = !isMainAvailable || !isAddonAvailable;
  const values = ["with", "none"];

  values.forEach(value => {
    const option = document.querySelector(
      `[data-addon-control][data-addon-id="${addonId}"][value="${value}"]`
    );
    const label = document.querySelector(
      `label[for="addon-${addonId}-${value}"]`
    );

    if (option && label) {
      if (shouldDisable) {
        label.classList.add("is-disabled");
        label.setAttribute("aria-disabled", "true");
        label.setAttribute("tabindex", "-1");
      } else {
        label.classList.remove("is-disabled");
        label.removeAttribute("aria-disabled");
        label.removeAttribute("tabindex");
      }
    }
  });
}

// アドオンがありのときにShop Payボタンを非表示にする
function updateBuyButtonsVisibility() {
  const hasSelectedAddons =
    document.querySelectorAll('[data-addon-control][value="with"]:checked')
      .length > 0;
  const shopifyPaymentButton = document.querySelector(
    ".shopify-payment-button"
  );

  if (shopifyPaymentButton) {
    if (hasSelectedAddons) {
      shopifyPaymentButton.style.setProperty("display", "none", "important");
    } else {
      shopifyPaymentButton.style.removeProperty("display");
    }
  }
}

window.addEventListener("DOMContentLoaded", function () {
  // ネイルチップが選択されたとき
  // マイサイズ
  if (
    document.querySelector(".oval_not_selectable") &&
    document.querySelector(".short_not_selectable") &&
    document.querySelector(".mediumalmond_not_selectable")
  ) {
    document.querySelector(`input[data-property-type="size"]`).disabled = true;
  }
  if (document.querySelector(".oval_not_selectable")) {
    if (document.querySelector(".my-size-list.oval"))
      document.querySelector(".my-size-list.oval").classList.add("disabled");
  } else if (document.querySelector(".short_not_selectable")) {
    if (document.querySelector(".my-size-list.short"))
      document.querySelector(".my-size-list.short").classList.add("disabled");
  } else if (document.querySelector(".mediumalmond_not_selectable")) {
    if (document.querySelector(".my-size-list.mediumalmond"))
      document
        .querySelector(".my-size-list.mediumalmond")
        .classList.add("disabled");
  }

  const productType = getProductType();
  const isFootNail = productType === "foot-nail";

  // カートボタンと未入力の項目名。下の if の中で入れるが、
  // 後から動くイベント処理（この if の外）でも読むので宣言は外に置く
  let cartBtn;
  let noticeText;

  // 1本単位
  // 該当の爪のサイズオプションの配列
  const relevantPartSelectors = document.getElementsByClassName(
    "select-relevant-part"
  );

  // 短くするオプションの配列
  const shorteningSelectors = document.querySelectorAll(
    ".option-shortening-block-wrap.individual select"
  );

  // 短くするオプションをそれぞれdisabled
  Array.from(shorteningSelectors).forEach(selector => {
    selector.disabled = true;
  });

  // 形ごとに選べる爪のサイズの上限が違うため、初期表示でも範囲外の番号を外す
  // 対象はスペアチップ・紛失分追加（商品タグ「1本追加購入」）だけ。
  // ほかの商品ページには data-nail-size-limits が無いので、この呼び出しは何もしない
  applyNailSizeLimit(getSelectedTipShapeType());

  // 初期化時はバリデーションメッセージを設定せず、checkProductRequirements()に委ねる

  // 数量が変わったとき
  // +,-ボタン押したとき
  const quantityInput = document.querySelector(".cart-popup input[name=quantity]");
  if (document.querySelector(".buy-one-addtional") && quantityInput) {
    quantityInput.dataset["value"] = quantityInput.value;
    document
      .querySelectorAll(".cart-popup .quantity-selector__button")
      .forEach(el => {
        el.addEventListener("click", () => {
          // 選択できる数が増えたとき（+）
          const maxOfrelevantPart = quantityInput.dataset["value"];
          if (
            maxOfrelevantPart < quantityInput.value &&
            count < quantityInput.value
          ) {
            document
              .getElementsByClassName("relevant-part-block-wrap")[0]
              .classList.remove("selected");
            // バリデーションメッセージはcheckProductRequirements()で統一管理
            cartBtn.disabled = true;
            quantityInput.dataset["value"] = quantityInput.value;
            // 選択できる数が減ったとき（-）
          } else if (
            quantityInput.value < maxOfrelevantPart &&
            quantityInput.value < count
          ) {
            const selected_options = document.querySelectorAll(
              ".select-relevant-part.open"
            );
            selected_options.forEach(option => {
              option.classList.remove("open");
              option.dataset["value"] = "";
              option.value = "";
              shorteningSelectors[Number(option.dataset["index"] - 1)].value =
                "";
              shorteningSelectors[
                Number(option.dataset["index"] - 1)
              ].disabled = true;
            });
            count = 0;
            quantityInput.dataset["value"] = quantityInput.value;
            document
              .getElementsByClassName("relevant-part-block-wrap")[0]
              .classList.remove("selected");
          } else if (
            quantityInput.value < maxOfrelevantPart &&
            quantityInput.value == count
          ) {
            quantityInput.dataset["value"] = quantityInput.value;
            document
              .getElementsByClassName("relevant-part-block-wrap")[0]
              .classList.add("selected");
            document.getElementById(
              "cart-button-relevant-part-notice"
            ).innerText = "";
            if (noticeText.length == 0) {
              cartBtn.disabled = false;
            }
          }
        });
      });
  }

  // 一本単位追加購入のカートボタン
  if (document.querySelector(".buy-one-addtional")) {
    cartBtn = document.querySelector(".buy-buttons.submit button");
    const noticeNode = getCachedElement(
      "#cart-button-notice",
      "cartButtonNotice"
    );
    const requiredEl = document.querySelectorAll(
      ".cart-popup input:required, .cart-popup select:required"
    );
    // 統合バリデーション: すべての必須フィールドを動的に取得
    noticeText = validateAllRequiredFields();

    // required属性を持つ要素もチェック
    requiredEl.forEach(el => {
      if (!el.value) {
        const fieldName = getFieldName(el);
        if (!noticeText.includes(fieldName)) {
          noticeText.push(fieldName);
        }
      }
    });

    // 初期メッセージ表示
    if (noticeText.length > 0) {
      getCachedElement("#cart-button-notice", "cartButtonNotice").innerText =
        formatValidationMessage(noticeText);
    } else {
      getCachedElement("#cart-button-notice", "cartButtonNotice").innerText =
        "";
    }

    // カスタム必須フィールドのイベント処理（チップの形等）
    const customRequiredInputs = document.querySelectorAll(
      '.cart-popup [data-required-field="true"] input'
    );
    customRequiredInputs.forEach(el => {
      el.addEventListener("change", () => {
        // 統合バリデーション: すべての必須フィールドを動的に取得
        noticeText = validateAllRequiredFields();

        // required属性を持つ要素もチェック
        requiredEl.forEach(reqEl => {
          if (!reqEl.value) {
            const fieldName = getFieldName(reqEl);
            if (!noticeText.includes(fieldName)) {
              noticeText.push(fieldName);
            }
          }
        });

        // チップの形の視覚的フィードバック
        const tipTypeTitle = document.querySelector(
          ".product-selector.tip-type .js-selector-title"
        );
        if (tipTypeTitle) {
          const isChecked = document.querySelector(
            `.cart-popup input[data-property-type="chip-type"]:checked`
          );
          tipTypeTitle.classList.toggle("not_selected", !isChecked);
        }

        // メッセージ更新
        if (noticeText.length > 0) {
          getCachedElement(
            "#cart-button-notice",
            "cartButtonNotice"
          ).innerText = formatValidationMessage(noticeText);
          noticeNode.dataset.selectedCheck = "";
        } else {
          getCachedElement(
            "#cart-button-notice",
            "cartButtonNotice"
          ).innerText = "";
          getCachedElement(
            "#cart-button-notice",
            "cartButtonNotice"
          ).dataset.selectedCheck = "true";

          if (document.getElementById("before_submit_check").checked === true) {
            document
              .querySelector(".buy-buttons.submit")
              .classList.remove("disabled");
          }
        }
      });
    });

    requiredEl.forEach(el => {
      if (!el.value) {
        cartBtn.disabled = true;
        const fieldName = getFieldName(el);
        if (!noticeText.includes(fieldName)) {
          noticeText.push(fieldName);
        }
      }
      el.addEventListener("change", () => {
        // 統合バリデーション: すべての必須フィールドを動的に取得
        noticeText = validateAllRequiredFields();

        // required属性を持つ要素もチェック
        requiredEl.forEach(reqEl => {
          if (!reqEl.value) {
            const fieldName = getFieldName(reqEl);
            if (!noticeText.includes(fieldName)) {
              noticeText.push(fieldName);
            }
          }
        });

        if (cartBtn.disabled === true) {
          getCachedElement(
            "#cart-button-notice",
            "cartButtonNotice"
          ).innerText = formatValidationMessage(noticeText);
        }
        if (noticeText.length == 0) {
          getCachedElement(
            "#cart-button-notice",
            "cartButtonNotice"
          ).innerText = "";
          getCachedElement(
            "#cart-button-notice",
            "cartButtonNotice"
          ).dataset.selectedCheck = "true";
          checkAndEnableCartButton();
        }
        if (
          noticeText.length == 0 &&
          document.getElementById("cart-button-relevant-part-notice")
            .innerText == ""
        ) {
          cartBtn.disabled = false;
        }
      });
    });
    if (cartBtn.disabled === true) {
      getCachedElement("#cart-button-notice", "cartButtonNotice").innerText =
        formatValidationMessage(noticeText);
    }

    if (
      noticeText.length == 0 &&
      document.getElementById("cart-button-relevant-part-notice").innerText ==
        ""
    ) {
      cartBtn.disabled = false;
    }
  }

  //該当の爪
  let count = 0;

  // 1本追加購入商品: 選択数に応じて価格を更新する
  function updatePriceByNailCount(selectedCount) {
    const priceContainer = document.querySelector(".price[data-base-price]");
    if (!priceContainer) return;
    const basePrice = Number(priceContainer.dataset.basePrice || 0);
    if (basePrice <= 0) return;
    const unitPrice = basePrice / 100;
    const newTotal = unitPrice * (selectedCount || 1);
    const priceElement = priceContainer.querySelector(".c-price__price");
    if (priceElement) {
      priceElement.textContent = newTotal.toLocaleString();
    }
    priceContainer.dataset.totalPrice = newTotal.toLocaleString();
  }

  Array.from(relevantPartSelectors).forEach((selector, index) => {
    selector.addEventListener("change", () => {
      // 爪のサイズが選択された & datasetにvaleが入っていないとき（）
      if (selector.value !== "" && selector.dataset["value"] === "") {
        // 選択中の爪のサイズをカウント+1
        count += 1;
        const maxOfrelevantPart = quantityInput
          ? quantityInput.value
          : relevantPartSelectors.length;

        // フットネイル以外:短くする加工がないため
        if (!isFootNail) {
          shorteningSelectors[index].disabled = false;
        }

        // 選択できる数が選択中の数以下
        if (maxOfrelevantPart <= count) {
          document
            .getElementsByClassName("relevant-part-block-wrap")[0]
            .classList.add("selected");
          selector.classList.add("open");

          document.getElementById(
            "cart-button-relevant-part-notice"
          ).innerText = "";

          if (noticeText.length == 0) {
            cartBtn.disabled = false;
          }

          // 選択できる数が選択中の数より大きい
        } else {
          document
            .getElementsByClassName("relevant-part-block-wrap")[0]
            .classList.remove("selected");
          selector.classList.add("open");
          // バリデーションメッセージはcheckProductRequirements()で統一管理
          cartBtn.disabled = true;
        }
        selector.dataset["value"] = selector.value;

        // 選択が解除されたとき
      } else if (selector.value === "") {
        count -= 1;
        const maxOfrelevantPart = quantityInput
          ? quantityInput.value
          : relevantPartSelectors.length;

        // フットネイル以外:短くする加工がないため
        if (!isFootNail) {
          shorteningSelectors[index].disabled = true;
        }

        // 選択できる数が選択中の数以下
        if (maxOfrelevantPart <= count) {
          document
            .getElementsByClassName("relevant-part-block-wrap")[0]
            .classList.add("selected");
          selector.classList.add("open");
          document.getElementById(
            "cart-button-relevant-part-notice"
          ).innerText = "";
          if (noticeText.length == 0) {
            cartBtn.disabled = false;
          }

          // 選択できる数が選択中の数より大きい
        } else {
          document
            .getElementsByClassName("relevant-part-block-wrap")[0]
            .classList.remove("selected");
          selector.classList.remove("open");
          // バリデーションメッセージはcheckProductRequirements()で統一管理
          cartBtn.disabled = true;
        }
        selector.dataset["value"] = selector.value;
      } else {
        selector.dataset["value"] = selector.value;
      }
      // 1本追加購入: 選択数に応じて価格を更新
      updatePriceByNailCount(count);
    });
  });
});

// 短くするオプションセレクター表示
// Liquid の onchange から呼ぶため、ここでは参照が無い
// eslint-disable-next-line no-unused-vars
function selectedOptionShortening(selectElement) {
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const optionValue = selectedOption.value;
  const detailsContainer = document.getElementById("shortening-details");

  if (!detailsContainer) {
    return;
  }

  if (optionValue === "use") {
    // 展開
    selectElement.setAttribute("aria-expanded", "true");
    detailsContainer.setAttribute("aria-hidden", "false");
    detailsContainer.setAttribute("data-option-state", "open");
    detailsContainer.classList.add("open");

    // 指選択のイベントリスナー追加
    initializeShorteningSelectors();
  } else {
    // 閉じる
    selectElement.setAttribute("aria-expanded", "false");
    detailsContainer.setAttribute("aria-hidden", "true");
    detailsContainer.setAttribute("data-option-state", "closed");
    detailsContainer.classList.remove("open");
  }
}

// 指選択のイベントリスナー初期化関数
function initializeShorteningSelectors() {
  const optionSelectors = document.querySelectorAll(
    ".select-shortening-option"
  );

  optionSelectors.forEach(option => {
    // 重複イベント回避
    option.removeEventListener("change", handleShorteningChange);
    option.addEventListener("change", handleShorteningChange);
  });
}

// イベントハンドラー関数
function handleShorteningChange(event) {
  // 新しいスティッキーバー連携処理
  updateShorteningPriceForStickyBar();

  // 既存の関数が存在する場合のみ呼び出し（現在はコメントアウト中）
  // if (typeof shorteninginputChanged === 'function') {
  //   shorteninginputChanged(event);
  // }
  if (typeof inputChanged === "function") {
    inputChanged(event, "shortening");
  }
}

// 新しい指選択用ハンドラー関数
// Liquid の onchange から呼ぶため、ここでは参照が無い
// eslint-disable-next-line no-unused-vars
function handleShorteningFingerChange() {
  updateShorteningPriceForStickyBar();
}

// スティッキーバー連携用の価格計算関数
function updateShorteningPriceForStickyBar() {
  const shorteningSelect = document.querySelector("#option-shortening");
  const fingerSelects = document.querySelectorAll(".select-shortening-option");
  const wrapper = document.querySelector(".shortening-selector-wrap");

  // useが選択されているかチェック
  function isShorteningEnabled() {
    return (
      shorteningSelect?.value === "use" &&
      shorteningSelect?.getAttribute("aria-expanded") === "true"
    );
  }

  // 前回状態を個別data属性から取得
  const previousTotal = Number(wrapper?.dataset.shorteningTotal || 0);

  // 合計価格計算
  let currentTotal = 0;
  let selectedCount = 0;
  if (isShorteningEnabled()) {
    fingerSelects.forEach(select => {
      if (select.value && select.value !== "") {
        const selectedOption = select.options[select.selectedIndex];
        const priceString = selectedOption?.dataset.price || "0";
        const price = Number(priceString.replace(/[,]/g, "")); // カンマを除去して数値に変換
        currentTotal += price;
        selectedCount++;
      }
    });
  }

  // 個別のdata属性に状態を保存
  if (wrapper) {
    wrapper.dataset.shorteningTotal = currentTotal;
    wrapper.dataset.shorteningCount = selectedCount;
    wrapper.dataset.shorteningLastUpdated = Date.now();
  }

  // 短くする加工専用の価格更新（差分計算済み）
  const priceElement = document.querySelector(
    ".product-sticky-bar .c-price__price"
  );
  const priceContainer = document.querySelector(
    ".product-sticky-bar .price[data-total-price]"
  );

  if (priceElement && priceContainer) {
    const currentDisplayTotal = Number(
      priceContainer.dataset.totalPrice?.replace(/,/g, "") || 0
    );
    const newDisplayTotal =
      currentDisplayTotal + (currentTotal - previousTotal);

    // 同期更新: data-total-price ↔ .c-price__price
    priceContainer.dataset.totalPrice = newDisplayTotal.toLocaleString();
    priceElement.textContent = newDisplayTotal.toLocaleString();
  }

  // スティッキーバー内のオプション表示を更新
  updateStickyOptionDisplay("shortening", currentTotal, isShorteningEnabled());
}

// スティッキーバーの価格表示を更新する関数
// 統一価格更新関数
function updateTotalPrice(optionId, newPrice) {
  const priceElement = document.querySelector(".c-price__price");
  const priceContainer = document.querySelector(".price[data-total-price]");

  if (!priceElement || !priceContainer) return;

  // 現在の合計価格を取得（data-total-priceから表示単位）
  const currentTotal = Number(
    priceContainer.dataset.totalPrice?.replace(/,/g, "") || 0
  );

  // 前回のオプション価格を取得
  const optionElement = document.getElementById(optionId);
  const oldOptionPrice = Number(
    optionElement?.dataset.price?.replace(/,/g, "") || 0
  );

  // 新しい合計価格を計算
  const newTotal = currentTotal - oldOptionPrice + newPrice;

  // 同期更新: data-total-price ↔ .c-price__price（表示単位で管理）
  priceContainer.dataset.totalPrice = newTotal.toLocaleString();
  priceElement.textContent = newTotal.toLocaleString();

  // オプション価格を保存
  if (optionElement) {
    optionElement.dataset.price = newPrice;
  }
}

// スティッキーバー内のオプション表示を更新する関数
function updateStickyOptionDisplay(optionId, price, isEnabled) {
  const spanElement = document.querySelector(`#${optionId}`);
  if (!spanElement) return;

  if (isEnabled && price > 0) {
    const formattedPrice = price.toLocaleString();
    const currencySymbol =
      document.querySelector(".c-price__currency")?.textContent || "";
    const optionTitle =
      window.i18n?.options?.shorteningProcessing || "短くする加工";
    spanElement.textContent = `${optionTitle}: +${currencySymbol}${formattedPrice}`;
    spanElement.setAttribute("data-price", price);
    spanElement.style.display = "inline";
  } else {
    spanElement.textContent = "";
    spanElement.setAttribute("data-price", "0");
    spanElement.style.display = "none";
  }
}

// 短くする加工の動的価格計算
// COMMENTED OUT: Existing shortening price calculation - replaced with new sticky bar integration
/*
function updateShorteningPrice() {
  const selectors = document.querySelectorAll('.select-shortening-option');
  let selectedCount = 0;
  let totalPrice = 0;

  selectors.forEach(selector => {
    if (selector.value !== '') {
      selectedCount++;
      const selectedOption = selector.options[selector.selectedIndex];
      const optionPrice = parseInt(selectedOption.dataset.price || '0');
      totalPrice += optionPrice;
    }
  });

  // データ属性を更新
  const priceElement = document.getElementById('js-shortening-price');
  const summaryElement = document.getElementById('js-shortening-summary');
  const countElement = document.getElementById('js-shortening-count');
  const totalElement = document.getElementById('js-shortening-total');

  if (summaryElement) {
    summaryElement.dataset.selectedCount = selectedCount;
    summaryElement.dataset.totalPrice = totalPrice;
  }

  if (priceElement) {
    priceElement.dataset.price = totalPrice;
  }

  // 表示を更新
  if (countElement) countElement.textContent = selectedCount;
  if (totalElement) totalElement.textContent = `${totalPrice.toLocaleString()}円`;
}
*/

// COMMENTED OUT: Old shortening input change handler - replaced with new sticky bar integration
/*
// 短くするオプションが選択・変更されたとき
function shorteninginputChanged(e) {
  const titleEl = document.querySelector("#option-shortening-title");
  const el = document.querySelector("#js-shortening-price");
  const optionListEl = document.querySelector(".opion-list");
  if (
    e.target.dataset["value"] != e.target.value &&
    !e.target.dataset["value"] &&
    e.target.value
  ) {
    titleEl.dataset.shorteningQuantity =
      Number(titleEl.dataset.shorteningQuantity) + 1;
    el.innerText = ` +${(
      Number(500) * titleEl.dataset.shorteningQuantity
    ).toLocaleString()}円`;
    // document.querySelector('.opion-list').innerText = document.querySelector('.opion-list').innerText + titleEl.innerText;
  }
  if (e.target.dataset["value"] && !e.target.value) {
    titleEl.dataset.shorteningQuantity =
      Number(titleEl.dataset.shorteningQuantity) - 1;
    el.innerText = ` +${(
      Number(500) * titleEl.dataset.shorteningQuantity
    ).toLocaleString()}円`;
    // if(( Number(titleEl.dataset.shorteningQuantity)) === 0) {
    //   document.querySelector('.opion-list').innerText = document.querySelector('.opion-list').innerText.replace(titleEl.innerText, '');
    // }
  }
  e.target.dataset["value"] = e.target.value;
}
*/

// 選択中のチップの形（内部名 oval / round / mediumalmond）を返す。未選択なら null
function getSelectedTipShapeType() {
  const checked = document.querySelector(
    'input[data-property-type="chip-type"]:checked'
  );
  return checked ? checked.id.replace("tip_type_", "") : null;
}

// 形ごとに選べる爪のサイズの上限が違う（10・11 番はミディアムアーモンドだけ）。
// 上限は snippets/c_nail-size-limits.liquid が data-nail-size-limits で渡す。
// この属性は商品タグ「1本追加購入」の商品（スペアチップ・紛失分追加）にしか出ないため、
// ほかの商品ページでは対象が 0 件になり、何も起きない。
// 形は画面上で切り替わるため Liquid では出し分けられず、ここで選択肢を組み直す。
// option の hidden / disabled は Safari が無視することがあるので、DOM から外す方法にする。
function applyNailSizeLimit(shapeType) {
  document.querySelectorAll("[data-nail-size-limits]").forEach(wrap => {
    const limits = {};
    wrap.dataset.nailSizeLimits.split(",").forEach(pair => {
      const [type, value] = pair.split(":");
      const limit = parseInt(value, 10);
      if (type && !isNaN(limit)) limits[type.trim()] = limit;
    });
    const allLimits = Object.values(limits);
    if (!allLimits.length) return;

    // 形が未選択のうちは、どの形にもある番号だけを出す
    const limit =
      limits[shapeType] !== undefined ? limits[shapeType] : Math.min(...allLimits);

    wrap.querySelectorAll(".select-relevant-part").forEach(select => {
      // 初回に全部の選択肢を控えておく（形を戻したときに復元するため）
      if (!select.nailSizeOptions) {
        select.nailSizeOptions = Array.from(select.options);
      }
      const previous = select.value;
      const allowed = select.nailSizeOptions.filter(option => {
        const size = parseInt(option.dataset.size, 10);
        // ✕（未選択）は data-size を持たないので常に残す
        return isNaN(size) || size <= limit;
      });
      select.replaceChildren(...allowed);

      // 外した番号が選ばれたままにならないよう空に戻し、既存の change 処理に伝える
      const keep = allowed.some(option => option.value === previous);
      select.value = keep ? previous : "";
      if (!keep && previous !== "") {
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });
}

function inputChanged(e, inputName) {
  const productType = getProductType();
  const isFootNail = productType === "foot-nail";

  switch (inputName) {
    // チップのタイプ：tip_type
    case "tip_type":
      if (isFootNail) {
        break;
      }
      document.getElementById("tip_type").innerText = e.target.value;

      // 形によって選べる爪のサイズの上限が違うため、範囲外の番号を外す
      applyNailSizeLimit(e.target.id.replace("tip_type_", ""));

      // マイサイズ選択の条件分岐 - DOM検索を最適化
      const hasSelectableOptions = !document.querySelector(
        ".oval_not_selectable, .short_not_selectable, .mediumalmond_not_selectable"
      );
      if (hasSelectableOptions) {
        const sizeInput = getPropertyElement("size");
        if (sizeInput) sizeInput.disabled = false;
      }
      if (
        e.target.value == window.i18n.productTypes.oval &&
        document.querySelector(".oval_not_selectable")
      ) {
        const sizeInputEl = getPropertyElement("size");
        if (sizeInputEl) {
          sizeInputEl.value = "";
          sizeInputEl.disabled = true;
        }
      } else if (
        e.target.value == window.i18n.productTypes.round &&
        document.querySelector(".short_not_selectable")
      ) {
        const sizeInputEl = getPropertyElement("size");
        if (sizeInputEl) {
          sizeInputEl.value = "";
          sizeInputEl.disabled = true;
        }
      }

      // ハンドネイル用のバリデーション処理を追加
      checkProductRequirements();
      break;

    // サイズのタイプ：size_type
    case "size_type":
      const sizeTypeElem = document.getElementById("size_type");
      sizeTypeElem.innerText = e.target.value;

      if (isFootNail) {
        toggleSizeFormLogic();
        // フットネイル用のバリデーション処理を追加
        checkProductRequirements();
      } else {
        // ハンドネイル用のバリデーション処理も追加
        checkProductRequirements();
      }

      break;

    // 短くするオプション：shortening
    case "shortening":
      // 短くする加工の価格処理は updateShorteningPriceForStickyBar で処理されるため
      // ここでは何もしない（統一価格システムに委ねる）
      break;

    // 親指ストレート：straight
    case "straight":
      const straightLabelText =
        e.target.dataset.label ||
        window.i18n?.labels?.thumbStraightTitle ||
        "親指ストレート加工";
      const isNotUse = isNotUseValue(e.target.value);

      if (!isNotUse) {
        const priceString = e.target.dataset.price || "0";
        const price = Number(priceString.replace(/[,]/g, "")); // カンマを除去して数値に変換
        const currencySymbol =
          document.querySelector(".c-price__currency")?.textContent || "";

        // 統一価格更新関数を使用
        updateTotalPrice("straight", price);

        document.getElementById("straight").innerText =
          `${straightLabelText}: +${currencySymbol}${price.toLocaleString()}`;
        document.getElementById("straight").style.display = "inline";
      } else {
        // 統一価格更新関数を使用（価格0で更新）
        updateTotalPrice("straight", 0);

        document.getElementById("straight").innerText = "";
        document.getElementById("straight").style.display = "none";
      }
      break;

    // 紛失補償：guarantee
    case "guarantee":
      const guaranteeLabelText =
        e.target.dataset.label ||
        window.i18n?.labels?.lossCompensationTitle ||
        "紛失補償";
      const isGuaranteeNotUse = isNotUseValue(e.target.value);

      if (!isGuaranteeNotUse) {
        const priceString = e.target.dataset.price || "0";
        const price = Number(priceString.replace(/[,]/g, ""));
        const currencySymbol =
          document.querySelector(".c-price__currency")?.textContent || "";

        // 統一価格更新関数を使用
        updateTotalPrice("guarantee", price);

        document.getElementById("guarantee").innerText =
          `${guaranteeLabelText}: +${currencySymbol}${price.toLocaleString()}`;
        document.getElementById("guarantee").style.display = "inline";
      } else {
        // 統一価格更新関数を使用（価格0で更新）
        updateTotalPrice("guarantee", 0);

        document.getElementById("guarantee").innerText = "";
        document.getElementById("guarantee").style.display = "none";
      }
      break;

    // スペアチップ追加：spare-tip
    case "spare-tip":
      const spareTipLabelText =
        e.target.dataset.label ||
        window.i18n?.labels?.spareTipTitle ||
        "スペアチップ";
      const isSpareTipNotUse = isNotUseValue(e.target.value);

      if (!isSpareTipNotUse) {
        const priceString = e.target.dataset.price || "0";
        const price = Number(priceString.replace(/[,]/g, ""));
        const currencySymbol =
          document.querySelector(".c-price__currency")?.textContent || "";

        // 統一価格更新関数を使用
        updateTotalPrice("spare-tip", price);

        document.getElementById("spare-tip").innerText =
          `${spareTipLabelText}: +${currencySymbol}${price.toLocaleString()}`;
        document.getElementById("spare-tip").style.display = "inline";
      } else {
        // 統一価格更新関数を使用（価格0で更新）
        updateTotalPrice("spare-tip", 0);

        document.getElementById("spare-tip").innerText = "";
        document.getElementById("spare-tip").style.display = "none";
      }
      break;

    // 配送：shipping
    case "shipping":
      const shippingLabelText =
        e.target.dataset.label ||
        window.i18n?.labels?.shippingOptionsLabel ||
        "配送オプション";
      const isShippingNotUse = isNotUseValue(e.target.value);

      if (!isShippingNotUse) {
        let price = 0;
        const selectedOption = e.target.selectedOptions[0];

        // より堅牢な判定：Express delivery（通常のお急ぎ便）
        if (
          e.target.value.includes("Express delivery") ||
          e.target.value.includes("お急ぎ便") ||
          e.target.value.includes("7 business days")
        ) {
          const priceString = selectedOption.dataset.price || "0";
          price = Number(priceString.replace(/[,]/g, ""));
        }
        // Super Express（超特急便）
        else if (
          e.target.value.includes("Super Express") ||
          e.target.value.includes("超特急便") ||
          e.target.value.includes("3 business days")
        ) {
          const priceString = selectedOption.dataset.price || "0";
          price = Number(priceString.replace(/[,]/g, ""));
        }

        if (price > 0) {
          const currencySymbol =
            document.querySelector(".c-price__currency")?.textContent || "";

          // 統一価格更新関数を使用
          updateTotalPrice("shipping", price);

          document.getElementById("shipping").innerText =
            `${shippingLabelText}: +${currencySymbol}${price.toLocaleString()}`;
          document.getElementById("shipping").style.display = "inline";
        }
      } else {
        // 統一価格更新関数を使用（価格0で更新）
        updateTotalPrice("shipping", 0);

        document.getElementById("shipping").innerText = "";
        document.getElementById("shipping").style.display = "none";
      }
      break;
  }
}

// 商品タイプの判定
function getProductType() {
  if (cachedProductType === null) {
    const cartPopup = getCachedElement("#cart-popup", "cartPopup");
    if (!cartPopup) {
      return null;
    }
    cachedProductType = cartPopup.dataset.productType;
  }
  return cachedProductType;
}

// フットネイル: サイズフォーム（#js-size-select-form）表示/非表示、<select>のdisabled, classの付与/削除
function toggleSizeFormLogic() {
  const radio = document.getElementById("tip-size-select");
  const formDiv = document.getElementById("js-size-select-form");

  // 修正: 実際のフォーム要素を検索
  let selects = formDiv.querySelectorAll(".c-foot-selector__select");

  // 新しいフォーム構造の場合: relevant-part セレクターを使用
  if (selects.length === 0) {
    selects = formDiv.querySelectorAll('select[id*="relevant-part"]');
  }

  if (radio.checked) {
    // チェック状態ならフォームを表示し、各 select を有効化
    formDiv.style.display = "block";
    formDiv.classList.add("is-foot-selector__selected");

    selects.forEach(function (s) {
      s.disabled = false;

      s.dataset.selectValue = s.value;

      // 初期表示時に value !== "-" なら selected クラスをつける
      if (s.value !== "-") {
        s.classList.add("is-foot-selector__select--selected");
      } else {
        s.classList.remove("is-foot-selector__select--selected");
      }

      // 既存リスナがあれば一旦外し、カスタム change ハンドラを再登録
      s.removeEventListener("change", footSelectChangeHandler);
      s.addEventListener("change", footSelectChangeHandler);
    });
  } else {
    // チェック外れならフォームを非表示、select を無効化してクラスをすべて削除
    formDiv.style.display = "none";
    formDiv.classList.remove("is-foot-selector__selected");

    selects.forEach(function (s) {
      s.disabled = true;
      s.dataset.selectValue = "";
      s.classList.remove("is-foot-selector__select--selected");
      s.removeEventListener("change", footSelectChangeHandler);
    });
  }
}

// フットネイル: data-select-valueの更新、classの付与・削除
function footSelectChangeHandler(e) {
  const s = e.currentTarget;
  s.dataset.selectValue = s.value;
  if (s.value !== "-") {
    s.classList.add("is-foot-selector__select--selected");
  } else {
    s.classList.remove("is-foot-selector__select--selected");
  }
}

// フットネイル: サイズが選択されているかを判定（boolean を返す）
function checkFootNailSizeSelection() {
  // 修正: 新旧両方のフォーム構造に対応
  let rightSelects = Array.from(
    document.querySelectorAll(
      ".c-foot-selector__side--right .c-foot-selector__select"
    )
  );
  let leftSelects = Array.from(
    document.querySelectorAll(
      ".c-foot-selector__side--left  .c-foot-selector__select"
    )
  );

  // 新しいフォーム構造の場合: relevant-part セレクターを使用
  if (rightSelects.length === 0 && leftSelects.length === 0) {
    rightSelects = Array.from(
      document.querySelectorAll('select[id*="relevant-part"][id*="Right"]')
    );
    leftSelects = Array.from(
      document.querySelectorAll('select[id*="relevant-part"][id*="Left"]')
    );
  }

  // すべてのサイズが選択されているかをチェック（1つでも未選択があればfalse）
  const allSelected = [...rightSelects, ...leftSelects].every(select => {
    if (select.dataset.selectValue !== undefined) {
      return (
        select.dataset.selectValue !== "-" &&
        select.classList.contains("is-foot-selector__select--selected")
      );
    } else {
      return select.value && select.value !== "" && select.value !== "✕";
    }
  });

  return allSelected;
}

// フットネイル: すべてのサイズが選択されているかをチェック、選択されていればサイズを返却
function buildFootNailString() {
  // 修正: 新旧両方のフォーム構造に対応
  let rightSelects = Array.from(
    document.querySelectorAll(
      ".c-foot-selector__side--right .c-foot-selector__select"
    )
  );
  let leftSelects = Array.from(
    document.querySelectorAll(
      ".c-foot-selector__side--left  .c-foot-selector__select"
    )
  );

  // 新しいフォーム構造の場合: relevant-part セレクターを使用
  if (rightSelects.length === 0 && leftSelects.length === 0) {
    rightSelects = Array.from(
      document.querySelectorAll('select[id*="relevant-part"][id*="Right"]')
    );
    leftSelects = Array.from(
      document.querySelectorAll('select[id*="relevant-part"][id*="Left"]')
    );
  }

  // 未選択チェック - 新旧両方の形式に対応
  [...rightSelects, ...leftSelects].forEach(select => {
    let isSelected = false;

    if (select.dataset.selectValue !== undefined) {
      // 古い形式: data-select-value を使用
      const hasSelectedClass = select.classList.contains(
        "is-foot-selector__select--selected"
      );
      const valueIsNotDash = select.dataset.selectValue !== "-";
      isSelected = hasSelectedClass && valueIsNotDash;
    } else {
      // 新しい形式: value を使用
      isSelected = select.value && select.value !== "" && select.value !== "✕";
    }

    if (!isSelected) {
      select.classList.add("c-foot-selector__select--warning");
    } else {
      select.classList.remove("c-foot-selector__select--warning");
    }
  });

  // すべてのサイズが選択されていることを確認する
  const hasAnySelected = [...rightSelects, ...leftSelects].every(select => {
    if (select.dataset.selectValue !== undefined) {
      return (
        select.dataset.selectValue !== "-" &&
        select.classList.contains("is-foot-selector__select--selected")
      );
    } else {
      return select.value && select.value !== "" && select.value !== "✕";
    }
  });

  if (!hasAnySelected) {
    return null;
  }
  const leftSizes = buildSizeString(leftSelects, false);
  const rightSizes = buildSizeString(rightSelects, false);

  return formatFootNailSizes(leftSizes, rightSizes);
}

// 共通: フットネイルセレクターを取得
function getFootNailSelects() {
  let rightSelects = Array.from(
    document.querySelectorAll(
      ".c-foot-selector__side--right .c-foot-selector__select"
    )
  );
  let leftSelects = Array.from(
    document.querySelectorAll(
      ".c-foot-selector__side--left .c-foot-selector__select"
    )
  );

  // 新しいフォーム構造の場合
  if (rightSelects.length === 0 && leftSelects.length === 0) {
    rightSelects = Array.from(
      document.querySelectorAll('select[id*="relevant-part"][id*="Right"]')
    );
    leftSelects = Array.from(
      document.querySelectorAll('select[id*="relevant-part"][id*="Left"]')
    );
  }

  return { rightSelects, leftSelects };
}

// 共通: 指の名前を多言語対応で取得
function getFingerName(select, fallbackLabel = null) {
  if (select.dataset.selectValue !== undefined) {
    // 古い形式: ラベル要素から取得
    const labelElem = select.previousElementSibling;
    return labelElem ? labelElem.textContent.trim() : fallbackLabel || "?";
  }

  // 新しい形式: ID から指の名前を多言語対応で取得
  const fingerTranslations = window.i18n?.fingers || {};
  const id = select.id;

  if (id.includes("Thumb")) return fingerTranslations.thumb || "Thumb";
  if (id.includes("Index")) return fingerTranslations.index || "Index";
  if (id.includes("Middle")) return fingerTranslations.middle || "Middle";
  if (id.includes("Ring")) return fingerTranslations.ring || "Ring";
  if (id.includes("Pinky")) return fingerTranslations.pinky || "Pinky";

  return fallbackLabel || "?";
}

// 共通: サイズ文字列を構築
function buildSizeString(selects, includeMySize = false) {
  const parts = selects
    .map(select => {
      const fingerName = getFingerName(select);
      let value = "";

      if (select.dataset.selectValue !== undefined) {
        value = select.dataset.selectValue;
      } else {
        value = select.value;
      }

      // マイサイズを含める場合のフォールバック
      if (includeMySize && (!value || value === "-")) {
        value = select.dataset.mySize || "-";
      }

      // バリデーション用の場合は「✕」もチェック
      const isValidValue = includeMySize
        ? value && value !== "-"
        : value && value !== "" && value !== "✕" && value !== "-";

      return isValidValue ? `${fingerName}${value}` : null;
    })
    .filter(part => part !== null);

  return parts.join(window.i18n?.footnail?.separator || " 、");
}

// 共通: 左右のサイズ文字列をフォーマット
function formatFootNailSizes(leftSizes, rightSizes) {
  if (!leftSizes && !rightSizes) return null;

  const leftLabel = window.i18n?.footnail?.left || "Left";
  const rightLabel = window.i18n?.footnail?.right || "Right";

  let result = "";
  if (leftSizes) result += `\n${leftLabel}：${leftSizes}`;
  if (rightSizes) result += `\n${rightLabel}：${rightSizes}`;

  return result;
}

// フットネイル: 現在選択されているサイズ情報を取得（マイサイズ更新対応）
function buildCurrentFootNailSizeString() {
  const { rightSelects, leftSelects } = getFootNailSelects();

  const leftSizes = buildSizeString(leftSelects, true);
  const rightSizes = buildSizeString(rightSelects, true);

  return formatFootNailSizes(leftSizes, rightSizes);
}

// フットネイル: サイズ「サイズを選択して注文」時の選択状態チェック
function checkSelectedStatus() {
  const noticeNode = getCachedElement(
    "#cart-button-notice",
    "cartButtonNotice"
  );
  const titleElem = document.querySelector(
    ".product-selector .js-selector-title"
  );
  const buttonElem = document.querySelector(".buy-buttons.submit");

  // 修正: 実際のフォーム要素を検索
  let allSelects = document.querySelectorAll(
    ".c-foot-selector__item .c-foot-selector__select"
  );

  // 新しいフォーム構造の場合: relevant-part セレクターを使用
  if (allSelects.length === 0) {
    allSelects = document.querySelectorAll('select[id*="relevant-part"]');
  }

  // バリデーションロジックを修正: checkFootNailSizeSelection()を使用
  const hasSelectedSizes = checkFootNailSizeSelection();
  const hasUnselected = !hasSelectedSizes;

  if (hasUnselected) {
    // 未選択がある
    titleElem.classList.add("not_selected");
    noticeNode.innerText = window.i18n.errors.selectSize;

    // フットネイル商品では常にボタンを無効化
    buttonElem.classList.add("disabled");
    buttonElem.disabled = true;

    // dataset.selectedCheckをfalseに設定してカート追加をブロック
    noticeNode.dataset.selectedCheck = "false";
  } else {
    // 全て選択済み
    titleElem.classList.remove("not_selected");
    noticeNode.innerText = "";
    noticeNode.dataset.selectedCheck = "true";

    // フットネイル商品では常にボタンを有効化
    buttonElem.classList.remove("disabled");
    buttonElem.disabled = false;
  }
}

// アドオン選択状態をチェック
function hasSelectedAddons() {
  const selectedAddons = document.querySelectorAll(
    '[data-addon-control][value="with"]:checked'
  );

  return selectedAddons.length > 0;
}

// 選択されたアドオン情報を取得
function getSelectedAddons() {
  const selectedInputs = document.querySelectorAll(
    '[data-addon-control][value="with"]:checked'
  );
  return Array.from(selectedInputs).map(input => ({
    addonId: input.dataset.addonId,
    variantId: input.dataset.variantId,
    price: parseInt(input.dataset.price) || 0,
    title: input.dataset.title,
    productId: input.dataset.productId,
  }));
}

// カートに複数アイテムを追加する共通処理
async function addItemsToCart(itemsToAdd) {
  const results = [];

  for (const item of itemsToAdd) {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(item),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || "カートへの追加に失敗しました");
    }

    results.push(await response.json());

    // 複数アイテムの場合は間隔をあける
    if (itemsToAdd.length > 1) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }
  }

  return results;
}

// カートドロワーを開く処理
function openCartDrawer() {
  const body = document.getElementsByTagName("body")[0];
  const CartDrawer = document.getElementsByTagName("cart-drawer")[0];

  if (CartDrawer) {
    body.append(CartDrawer);
    CartDrawer.style.display = "block";
    CartDrawer.setAttribute("open", "");

    // cart:refreshイベントを発火してカート内容を更新
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );
  }
}

function handleCartAddSuccess() {
  // カートのポップアップ処理
  const cartPopupElement = document.getElementById("cart-popup");
  if (cartPopupElement) {
    cartPopupElement.classList.remove("open");

    // カートポップアップ関連の要素を初期状態に戻す
    const cartButton = document.querySelector(".js-cart-popup-trigger");
    if (cartButton) {
      cartButton.innerText = "カートに入れる";
      cartButton.style.background = "#333";
      cartButton.style.color = "#fff";
    }

    const submitButton = document.querySelector(".buy-buttons.submit");
    if (submitButton) {
      submitButton.style.display = "none";
    }

    const mainElement = document.getElementById("main");
    if (mainElement) {
      mainElement.style.position = "";
    }

    const headerElement = document.getElementsByTagName("header")[0];
    if (headerElement) {
      headerElement.style.position = "";
    }

    const stickyBar = document.getElementsByTagName("product-sticky-bar")[0];
    if (stickyBar && stickyBar.classList.contains("menu-opened")) {
      stickyBar.classList.remove("menu-opened");
    }
  }

  sessionStorage.setItem("from-cart-added", "true");
  openCartDrawer();
}

// アドオン対応のカート追加処理
async function addToCartWithAddonSupport(e, hasAddons = false) {
  try {
    const form =
      e.target.closest("form") ||
      document.querySelector('form[action*="/cart/add"]');
    const formData = new FormData(form);

    // フットネイル商品のチップの形をFormDataに追加（フォーム外の要素対応）
    const tipTypeFootElement = document.getElementById("tip_type_foot");
    if (
      tipTypeFootElement &&
      tipTypeFootElement.value &&
      tipTypeFootElement.name
    ) {
      formData.append(tipTypeFootElement.name, tipTypeFootElement.value);
    }

    const groupId = hasAddons
      ? Date.now().toString() + "_" + Math.random().toString(36).substr(2, 9)
      : null;

    // メイン商品
    // 1本追加購入のネイルチップ商品では数量セレクターが非表示のため、
    // 選択された爪のサイズ数から数量を算出する（data-value属性はchangeイベントで更新される）
    const selectedNailSizeCount = document.querySelectorAll(
      '.select-relevant-part:not([data-value=""])'
    ).length;

    const mainItem = {
      id: formData.get("id") || e.target.dataset.variantId,
      quantity:
        parseInt(formData.get("quantity")) ||
        parseInt(document.querySelector(".quantity-selector__input")?.value) ||
        selectedNailSizeCount ||
        1,
      properties: {},
    };

    if (hasAddons && groupId) {
      mainItem.properties["_グループID"] = groupId;
      mainItem.properties["_商品タイプ"] = "メイン商品";
    }

    // 商品テンプレート
    const productRerenderElement = document.querySelector(
      "product-rerender[data-template-suffix]"
    );
    if (productRerenderElement) {
      const templateSuffix = productRerenderElement.dataset.templateSuffix;
      mainItem.properties["_商品テンプレート"] = templateSuffix;
    }

    // propertiesを追加
    for (const [key, value] of formData.entries()) {
      if (key.startsWith("properties[") && key.endsWith("]")) {
        const propKey = key.slice(11, -1);
        if (!propKey.startsWith("_")) {
          mainItem.properties[propKey] = value;
        }
      }
    }

    // アドオン商品情報をPropertyに追加
    const addonContainers = document.querySelectorAll("[data-addon-ui-id]");
    addonContainers.forEach(container => {
      const addonLabel = container.dataset.label;
      const addonId = container.dataset.addonUiId;
      const addonControl = document.querySelector(
        `[data-addon-control][data-addon-id="${addonId}"]:checked`
      );

      if (addonControl && addonLabel) {
        mainItem.properties[addonLabel] = addonControl.dataset.propertyValue;
      }
    });

    const itemsToAdd = [mainItem];

    // アドオン商品を追加
    if (hasAddons) {
      const selectedAddons = getSelectedAddons();
      selectedAddons.forEach(addon => {
        itemsToAdd.push({
          id: addon.variantId,
          quantity: mainItem.quantity,
          properties: {
            _グループID: groupId,
            _商品タイプ: "オプション商品",
            _オプション商品名: addon.title,
            _メイン商品: mainItem.id,
          },
        });
      });
    }

    // カートにアイテムを追加
    await addItemsToCart(itemsToAdd);

    // 成功時の処理
    handleCartAddSuccess();
  } catch (error) {
    // エラー時はボタンを元に戻す
    const submitButton = e.target;
    submitButton.innerText = window.i18n?.ui?.addToCart || "カートに追加";
    submitButton.disabled = false;

    // エラーメッセージの多言語対応
    const errorMessage =
      error.message ||
      window.i18n?.status?.failed ||
      "カートへの追加に失敗しました";

    // エラー分類と処理
    let errorType = "error";
    if (error.name === "NetworkError" || errorMessage.includes("network")) {
      errorType = "network";
    } else if (errorMessage.includes("※")) {
      errorType = "validation";
    }

    const productType = getProductType();
    const isFootNail = productType === "foot-nail";

    // 新しいエラー通知システムを使用
    showUserError(errorMessage, {
      isFootNail: isFootNail,
      type: errorType,
      duration: errorType === "validation" ? 5000 : 3000,
    });
  } finally {
    // 将来的なクリーンアップ処理用
  }
}

/**
 * オプション商品の数量を判定
 * @param {string|null} variantId - Variant ID
 * @returns {number} - 数量（0または1）
 */
function getOptionQuantity(variantId) {
  return variantId ? 1 : 0;
}

/**
 * お急ぎ便オプションの情報を取得
 * @returns {Object} - {variantId, quantity, value}
 */
function getExpressDeliveryOption() {
  const element = getPropertyElement("express-delivery");

  if (!element) {
    return { variantId: null, quantity: 0, value: null };
  }

  const variantId = getPropertyVariantId("express-delivery");
  const quantity = getOptionQuantity(variantId);
  const value = getPropertyValue("express-delivery");

  return { variantId, quantity, value };
}

/**
 * お急ぎ便アイテムをカートアイテムリストに追加
 * @param {Array} items - カートアイテムリスト
 * @param {string} productTitle - 適用される商品名
 * @param {string} groupId - グループID
 */
function addExpressDeliveryToCart(items, productTitle, groupId) {
  const expressOption = getExpressDeliveryOption();

  if (expressOption.variantId && expressOption.quantity > 0) {
    items.push({
      id: Number(expressOption.variantId),
      quantity: Number(expressOption.quantity),
      properties: {
        [getPropertyKey("applicable_product")]: productTitle,
        _グループID: groupId,
      },
    });
  }
}

/**
 * 紛失補償オプションの情報を取得
 * @returns {Object} - {variantId, quantity}
 */
function getLossCompensationOption() {
  const variantId = getPropertyVariantId("loss-compensation");
  const quantity = getOptionQuantity(variantId);
  return { variantId, quantity };
}

/**
 * スペアチップ追加オプションの情報を取得
 * @returns {Object} - {variantId, quantity}
 */
function getSpareTypOption() {
  const variantId = getPropertyVariantId("spare-tip");
  const quantity = getOptionQuantity(variantId);
  return { variantId, quantity };
}

/**
 * 紛失補償アイテムをカートアイテムリストに追加
 * @param {Array} items - カートアイテムリスト
 * @param {string} productTitle - 適用される商品名
 * @param {string} groupId - グループID
 */
function addLossCompensationToCart(items, productTitle, groupId) {
  const option = getLossCompensationOption();

  if (option.variantId && option.quantity > 0) {
    items.push({
      id: Number(option.variantId),
      quantity: Number(option.quantity),
      properties: {
        [getPropertyKey("applicable_product")]: productTitle,
        _グループID: groupId,
      },
    });
  }
}

/**
 * スペアチップ追加アイテムをカートアイテムリストに追加
 * @param {Array} items - カートアイテムリスト
 * @param {string} productTitle - 適用される商品名
 * @param {string} groupId - グループID
 */
function addSpareTypToCart(items, productTitle, groupId) {
  const option = getSpareTypOption();

  if (option.variantId && option.quantity > 0) {
    items.push({
      id: Number(option.variantId),
      quantity: Number(option.quantity),
      properties: {
        [getPropertyKey("applicable_product")]: productTitle,
        _グループID: groupId,
      },
    });
  }
}

/**
 * 親指ストレート加工オプションの情報を取得
 * @returns {Object} - {variantId, quantity}
 */
function getThumbStraightOption() {
  const variantId = getPropertyVariantId("thumb-straight");
  const quantity = getOptionQuantity(variantId);
  return { variantId, quantity };
}

/**
 * 親指ストレート加工アイテムをカートアイテムリストに追加
 * @param {Array} items - カートアイテムリスト
 * @param {string} productTitle - 適用される商品名
 * @param {string} groupId - グループID
 */
function addThumbStraightToCart(items, productTitle, groupId) {
  const option = getThumbStraightOption();

  if (option.variantId && option.quantity > 0) {
    items.push({
      id: Number(option.variantId),
      quantity: Number(option.quantity),
      properties: {
        [getPropertyKey("applicable_product")]: productTitle,
        _グループID: groupId,
      },
    });
  }
}

/**
 * 短くする加工オプションの情報を取得
 * @returns {Object} - {variantId, quantity}
 */
function getShorteningOption() {
  const element = getPropertyElement("shortening");

  if (!element) {
    return { variantId: null, quantity: 0 };
  }

  // 短くする加工が「利用する」に設定されているかチェック
  const value = getPropertyValue("shortening");
  const isUsingShortening = value === "use";

  if (!isUsingShortening) {
    return { variantId: null, quantity: 0 };
  }

  // 個別の指選択から実際の数量を計算
  const fingerSelects = document.querySelectorAll(".select-shortening-option");
  let selectedCount = 0;

  fingerSelects.forEach(select => {
    if (select.value && select.value !== "") {
      selectedCount++;
    }
  });

  if (selectedCount > 0) {
    const variantId = getPropertyVariantId("shortening");
    return { variantId, quantity: selectedCount };
  }

  return { variantId: null, quantity: 0 };
}

/**
 * 短くする加工アイテムをカートアイテムリストに追加
 * @param {Array} items - カートアイテムリスト
 * @param {string} productTitle - 適用される商品名
 * @param {string} groupId - グループID
 */
function addShorteningToCart(items, productTitle, groupId) {
  const option = getShorteningOption();

  if (option.variantId && option.quantity > 0) {
    items.push({
      id: Number(option.variantId),
      quantity: Number(option.quantity),
      properties: {
        [getPropertyKey("applicable_product")]: productTitle,
        _グループID: groupId,
      },
    });
  }
}

// 重複クリック防止付きのaddToCart関数
// Liquid の onclick から呼ぶため、ここでは参照が無い
// eslint-disable-next-line no-unused-vars
async function addToCart(e) {
  const button = e.target;
  const buttonId = cartController.getButtonId(button);

  // 重複クリックチェック
  if (cartController.processingButtons.has(buttonId)) {
    e.preventDefault();
    return { success: false, reason: "duplicate_click" };
  }

  // 処理開始
  const originalState = cartController.setProcessingState(button);
  cartController.processingButtons.set(buttonId, originalState);

  try {
    // 既存のカート追加処理を実行
    const result = await executeOriginalAddToCart(e);
    return { success: true, data: result };
  } catch (error) {
    // エラー表示（既存のエラーハンドリングを活用）
    if (typeof showUserError === "function") {
      showUserError(error.message || "カート追加に失敗しました", {
        type: "error",
        duration: 3000,
      });
    }

    return { success: false, error: error.message };
  } finally {
    // 確実な状態復元
    cartController.restoreButtonState(button, originalState);
    cartController.processingButtons.delete(buttonId);
  }
}

// 既存のaddToCart処理ロジック
function executeOriginalAddToCart(e) {
  return new Promise((resolve, reject) => {
    try {
      const cartPopup = document.getElementById("cart-popup");
      const addonElements = document.querySelectorAll("[data-addon-control]");

      // cart-popup と アドオン要素のチェック: 通常のカートに追加処理では実行なし
      if (!cartPopup && addonElements.length === 0) {
        // 早期リターンせずに通常のカート追加処理を継続する
      }

      // アドオン要素が存在する場合の処理
      if (addonElements.length > 0) {
        e.preventDefault();

        if (hasSelectedAddons()) {
          addToCartWithAddonSupport(e, true);
        } else {
          addToCartWithAddonSupport(e, false);
        }
        resolve({ success: true, message: "Addon cart addition handled" });
        return;
      }

      // 「注文内容が正しいことを確認しました」をチェック
      // 1本追加購入商品では確認チェックボックスが存在しない場合がある
      const beforeSubmitCheck = document.getElementById("before_submit_check");
      if (beforeSubmitCheck && !beforeSubmitCheck.checked) {
        resolve({
          success: false,
          message: "Confirmation checkbox not checked",
        });
        return;
      }

      // メイン商品にプロパティ値の追加
      const productType = getProductType();
      const isFootNail = productType === "foot-nail";

      // フットネイル特有のバリデーション
      if (isFootNail) {
        try {
          validateFootNailInputs();
        } catch (error) {
          showUserError(error.message, {
            isFootNail: true,
            type: "validation",
            duration: 5000,
          });
          return; // バリデーション失敗時は処理を中断
        }
      }

      // ユニークなグループIDを生成（タイムスタンプ + ランダム文字列）
      const groupId =
        Date.now().toString() + "_" + Math.random().toString(36).substr(2, 9);

      // 必須項目の選択状態をチェック
      const cartButtonNotice = getCachedElement(
        "#cart-button-notice",
        "cartButtonNotice"
      );
      if (
        cartButtonNotice &&
        cartButtonNotice.dataset.selectedCheck !== "true"
      ) {
        // フットネイル、サイズを選択して注文の場合は未選択項目にclassを付与
        if (isFootNail) {
          const selectedSize = document.querySelector(
            'input[data-property-type="size"]:checked'
          )?.value;

          if (selectedSize === window.i18n?.sizeTypes?.selectSizeToOrder) {
            const footString = buildFootNailString();
            if (footString === null) {
              event.preventDefault();
              resolve({
                success: false,
                message: "buildFootNailString returned null",
              });
              return;
            }
          } else if (selectedSize) {
            const checkedSizeElement = document.querySelector(
              '[data-property-type="size"]:checked'
            );
            if (
              checkedSizeElement &&
              (checkedSizeElement.dataset.sizeMode === "my-size" ||
                checkedSizeElement.id === "tip_size_mysize")
            ) {
              const hasSelectedSizes = checkFootNailSizeSelection();
              if (!hasSelectedSizes) {
                event.preventDefault();
                resolve({
                  success: false,
                  message: "マイサイズ更新でサイズが未選択です",
                });
                return;
              }
            }
          }
        }
        resolve({ success: false, message: "Required fields not selected" });
        return;
      }
      const productTitle =
        document.querySelector(".product-title.h3").innerText;
      const productVariantId = e.target.dataset.variantId;
      const quantitySelector = document.querySelector(
        ".quantity-selector__input "
      );
      // 1本追加購入のネイルチップ商品では数量セレクターが非表示のため、
      // 選択された爪のサイズ数から数量を算出する
      const selectedNailSizeCount = document.querySelectorAll(
        '.select-relevant-part:not([data-value=""])'
      ).length;
      const productQuantity = quantitySelector
        ? quantitySelector.value
        : selectedNailSizeCount || 1;
      const noticeNode = getCachedElement(
        "#cart-button-notice",
        "cartButtonNotice"
      );
      const properties = new Object();

      // グループIDをpropertiesに追加
      properties["_グループID"] = groupId;

      const hasTag = hasAdditionalPurchaseTag();

      if (hasTag) {
        // フットネイル時はhiddenタイプのinputを用いているため条件を分ける
        if (productType !== "foot-nail") {
          const chipTypeCheckedEl = document.querySelector(
            'input[data-property-type="chip-type"]:checked'
          );
          const chipTypeKey =
            chipTypeCheckedEl?.dataset?.propertyKey || "チップの種類";
          properties[chipTypeKey] = chipTypeCheckedEl
            ? chipTypeCheckedEl.value
            : "";
        } else {
          const chipTypeEl = getPropertyElement("chip-type");
          const chipTypeKey =
            chipTypeEl?.dataset?.propertyKey ||
            window.i18n?.properties?.chipType ||
            "チップの種類";
          properties[chipTypeKey] = chipTypeEl ? chipTypeEl.value : "";
        }

        // ポップアップフォーム内から取得
        // フットネイル商品の追加入力項目をpropertiesに設定
        // または1本単位で購入の時はチップの形以外の項目をpropertiesに設定
        if (productType === "foot-nail" || hasTag) {
          const popupForm = document.querySelector(".popup-wrap");
          if (popupForm) {
            // Use data attributes to extract properties dynamically
            const propertyElements = popupForm.querySelectorAll(
              "[data-property-type][data-property-key]"
            );

            // フットネイルはすべてを対象
            if (productType === "foot-nail") {
              propertyElements.forEach(element => {
                const propertyKey = element.getAttribute("data-property-key");
                const propertyValue = element.value || "";
                if (propertyKey && propertyValue) {
                  properties[propertyKey] = propertyValue;
                }
              });
            } else if (hasTag) {
              // 1本単位で購入
              const chipShapeKey =
                window.i18n?.properties?.chipType || "チップの形";
              propertyElements.forEach(element => {
                const propertyKey = element.getAttribute("data-property-key");
                const propertyValue = element.value || "";
                if (
                  propertyKey &&
                  propertyValue &&
                  propertyKey !== chipShapeKey
                ) {
                  properties[propertyKey] = propertyValue;
                }
              });
            }
          }
        }
        // Collect finger size properties using generic selectors that work for all languages
        const fingerSelectors = document.querySelectorAll(
          'select[data-property-type="size"]'
        );

        fingerSelectors.forEach(element => {
          if (element && element.value !== "" && element.value !== "✕") {
            // Extract property key from the element's name attribute
            const nameMatch = element.name.match(/properties\[(.+)\]/);
            if (nameMatch) {
              // 該当箇所と爪のサイズのフォーマット（例：該当箇所と爪のサイズ：中(右)）
              // nameMatch[1]は既に完全なプロパティキー
              const propertyKey = nameMatch[1];
              properties[propertyKey] = element.value;
            }
          }
        });
      } else if (productType === "nail-tip") {
        const chipTypeCheckedEl = document.querySelector(
          'input[data-property-type="chip-type"]:checked'
        );
        const chipTypeKey =
          chipTypeCheckedEl?.dataset?.propertyKey || "チップの種類";
        properties[chipTypeKey] = chipTypeCheckedEl
          ? chipTypeCheckedEl.value
          : "";
        const sizeCheckedEl = document.querySelector(
          'input[data-property-type="size"]:checked'
        );
        const sizeKey = sizeCheckedEl?.dataset?.propertyKey || "サイズ";
        properties[sizeKey] = sizeCheckedEl ? sizeCheckedEl.value : "";
        if (
          properties[sizeKey] !==
          window.i18n?.sizeTypes?.registerSizeAfterPurchase
        ) {
          // マイサイズで注文の場合の処理
          const mySizeKey = window.i18n?.properties?.mySize || "マイサイズ";
          properties[mySizeKey] = "";
          // オーバル
          if (
            document.querySelector(
              'input[data-property-type="chip-type"]:checked'
            ).value === window.i18n.productTypes.oval
          ) {
            const elementOvalLeft = document.getElementById("oval-left");
            const elementOvalRight = document.getElementById("oval-right");

            if (!elementOvalLeft || !elementOvalRight) {
              noticeNode.innerText = window.i18n.errors.selectSize;
              resolve({ success: false, message: "Oval size not selected" });
              return;
            }

            properties[window.i18n.productTypes.oval] =
              "\n" +
              elementOvalLeft.innerText +
              "\n" +
              elementOvalRight.innerText;
          }
          // ラウンド(ショート)
          if (
            document.querySelector(
              'input[data-property-type="chip-type"]:checked'
            ).value === window.i18n.productTypes.round
          ) {
            const elementshortLeft = document.getElementById("short-left");
            const elementshortRight = document.getElementById("short-right");

            if (!elementshortLeft || !elementshortRight) {
              noticeNode.innerText = window.i18n.errors.selectSize;
              resolve({ success: false, message: "Round size not selected" });
              return;
            }

            properties[window.i18n.productTypes.round] =
              "\n" +
              elementshortLeft.innerText +
              "\n" +
              elementshortRight.innerText;
          }
          // ミディアムアーモンド
          if (
            document.querySelector(
              'input[data-property-type="chip-type"]:checked'
            ).value === window.i18n.productTypes.mediumAlmond
          ) {
            const elementMediumalmondLeft = document.getElementById(
              "js-mediumalmond-left"
            );
            const elementMediumalmondRight = document.getElementById(
              "js-mediumalmond-right"
            );

            if (!elementMediumalmondLeft || !elementMediumalmondRight) {
              noticeNode.innerText = window.i18n.errors.selectSize;
              resolve({
                success: false,
                message: "Medium almond size not selected",
              });
              return;
            }

            properties[window.i18n.productTypes.mediumAlmond] =
              "\n" +
              elementMediumalmondLeft.innerText +
              "\n" +
              elementMediumalmondRight.innerText;
          }
        }
      } else if (productType === "foot-nail") {
        const chipTypeEl = getPropertyElement("chip-type");
        const chipTypeKey =
          chipTypeEl?.dataset?.propertyKey ||
          window.i18n?.properties?.chipType ||
          "チップの種類";
        properties[chipTypeKey] = chipTypeEl ? chipTypeEl.value : "";
        const sizeCheckedEl = document.querySelector(
          'input[data-property-type="size"]:checked'
        );
        const sizeKey =
          sizeCheckedEl?.dataset?.propertyKey ||
          window.i18n?.properties?.size ||
          "サイズ";
        properties[sizeKey] = sizeCheckedEl ? sizeCheckedEl.value : "";

        // フットネイル商品の追加入力項目をpropertiesに設定（data属性ベース）
        const popupForm = document.querySelector(".popup-wrap");
        if (popupForm) {
          const orderNumberEl = popupForm.querySelector(
            '[data-property-type="order-number"]'
          );
          const orderNumberKey =
            orderNumberEl?.dataset?.propertyKey || "注文番号";
          if (orderNumberEl && orderNumberEl.value) {
            properties[orderNumberKey] = orderNumberEl.value;
          }

          const customerNameEl = popupForm.querySelector(
            '[data-property-type="customer-name"]'
          );
          const customerNameKey =
            customerNameEl?.dataset?.propertyKey || "お名前";
          if (customerNameEl && customerNameEl.value) {
            properties[customerNameKey] = customerNameEl.value;
          }

          const targetProductEl = popupForm.querySelector(
            '[data-property-type="target-product"]'
          );
          const targetProductKey =
            targetProductEl?.dataset?.propertyKey || "該当商品名";
          if (targetProductEl && targetProductEl.value) {
            properties[targetProductKey] = targetProductEl.value;
          }
        }

        if (
          properties[sizeKey] === window.i18n?.sizeTypes?.orderWithMySize ||
          properties[sizeKey] ===
            (window.i18n?.footnail?.product_page?.update_my_size_to_order ||
              "マイサイズを更新して注文")
        ) {
          // マイサイズで注文: 選択されたサイズまたは既存マイサイズを使用
          const footNailKey = window.i18n?.productTypes?.foot || "フットネイル";
          const currentFootSizeString = buildCurrentFootNailSizeString();

          if (currentFootSizeString) {
            properties[footNailKey] = currentFootSizeString;
          }
        } else if (
          properties[sizeKey]?.toLowerCase() ===
            window.i18n?.sizeTypes?.selectSizeToOrder?.toLowerCase() ||
          properties[sizeKey]?.toLowerCase() ===
            window.i18n?.footnail?.product_page?.select_size_to_order?.toLowerCase()
        ) {
          const footString = buildFootNailString();
          if (footString === null) {
            event.preventDefault();
            resolve({ success: false, message: "Foot nail string is null" });
            return;
          }

          const footNailKey = window.i18n?.productTypes?.foot || "フットネイル";
          properties[footNailKey] = footString;
        }
      }

      // フットネイル商品のチップの形を追加（フォーム外の要素対応）
      if (isFootNail) {
        const tipTypeFootElement = document.getElementById("tip_type_foot");
        if (tipTypeFootElement && tipTypeFootElement.value) {
          const propKey = tipTypeFootElement.name.slice(11, -1); // "properties[xxx]" から "xxx" を抽出
          properties[propKey] = tipTypeFootElement.value;
        }
      }

      // 短くする加工の詳細選択項目
      // Collect shortening properties using data-property-type instead of hardcoded names
      const shorteningMainSelect = getPropertyElement("shortening");
      if (shorteningMainSelect) {
        const shorteningKey =
          shorteningMainSelect.dataset?.propertyKey || "短くする加工";
        const selectedOption =
          shorteningMainSelect.options[shorteningMainSelect.selectedIndex];
        const displayText = selectedOption?.dataset.displayText;
        properties[shorteningKey] = displayText || shorteningMainSelect.value;
      }

      // Collect individual shortening finger selections
      const shorteningFingerSelects = document.querySelectorAll(
        ".select-shortening-option"
      );
      shorteningFingerSelects.forEach(selector => {
        if (selector && selector.value !== "" && selector.value !== "✕") {
          // Extract property key from the element's name attribute
          const nameMatch = selector.name.match(/properties\[(.+)\]/);
          if (nameMatch) {
            // 短くする加工のフォーマット（例：短くする加工_親(右): 5mm）
            const shorteningKey = getPropertyKey("shortening");
            const originalLocation = nameMatch[1]; // 翻訳キーから元の日本語表記を取得

            // TODO: i18nでの翻訳システムに移行
            // 翻訳キーから元の日本語位置名を抽出（例：'properties.thumb_right' -> '親(右)'）
            let japaneseLocation = originalLocation;
            if (originalLocation.includes("thumb_right"))
              japaneseLocation = "親(右)";
            else if (originalLocation.includes("index_right"))
              japaneseLocation = "人(右)";
            else if (originalLocation.includes("middle_right"))
              japaneseLocation = "中(右)";
            else if (originalLocation.includes("ring_right"))
              japaneseLocation = "薬(右)";
            else if (originalLocation.includes("pinky_right"))
              japaneseLocation = "小(右)";
            else if (originalLocation.includes("thumb_left"))
              japaneseLocation = "親(左)";
            else if (originalLocation.includes("index_left"))
              japaneseLocation = "人(左)";
            else if (originalLocation.includes("middle_left"))
              japaneseLocation = "中(左)";
            else if (originalLocation.includes("ring_left"))
              japaneseLocation = "薬(左)";
            else if (originalLocation.includes("pinky_left"))
              japaneseLocation = "小(左)";

            const localizedLocation =
              getLocalizedLocationName(japaneseLocation);
            const propertyKey = `${shorteningKey}_${localizedLocation}`;
            properties[propertyKey] = selector.value;
          }
        }
      });

      // 親指ストレート加工
      const thumbStraightSelect = getPropertyElement("thumb-straight");
      if (thumbStraightSelect) {
        const thumbStraightKey =
          thumbStraightSelect.dataset?.propertyKey || "親指ストレート加工";
        properties[thumbStraightKey] = thumbStraightSelect.value;
      }

      // 紛失補償
      const lossCompensationSelect = getPropertyElement("loss-compensation");
      if (lossCompensationSelect) {
        const lossCompensationKey =
          lossCompensationSelect.dataset?.propertyKey || "紛失補償";
        properties[lossCompensationKey] = lossCompensationSelect.value;
      }

      // スペアチップ追加
      const spareTipSelect = getPropertyElement("spare-tip");
      if (spareTipSelect) {
        const spareTipKey =
          spareTipSelect.dataset?.propertyKey || "スペアチップ";
        properties[spareTipKey] = spareTipSelect.value;
      }

      // お急ぎ便
      const expressDeliverySelect = getPropertyElement("express-delivery");
      if (expressDeliverySelect) {
        const expressDeliveryKey =
          expressDeliverySelect.dataset?.propertyKey || "お急ぎ便";
        properties[expressDeliveryKey] = expressDeliverySelect.value;
      }

      // カートに追加するオプション配列初期値
      const optionItem = {
        items: [],
      };

      // メイン商品
      optionItem.items.push({
        id: Number(productVariantId),
        quantity: Number(productQuantity),
        properties,
      });

      // 各オプションを関数で追加
      addThumbStraightToCart(optionItem.items, productTitle, groupId);
      addShorteningToCart(optionItem.items, productTitle, groupId);
      addLossCompensationToCart(optionItem.items, productTitle, groupId);
      addSpareTypToCart(optionItem.items, productTitle, groupId);
      addExpressDeliveryToCart(optionItem.items, productTitle, groupId);

      // カートに一括追加（optionItem.itemsを使用）
      addItemsToCart(optionItem.items)
        .then(() => {
          handleCartAddSuccess();
        })
        .catch(error => {
          const cartPopup = getCachedElement("#cart-popup", "cartPopup");
          if (cartPopup) {
            cartPopup.classList.remove("open");
          }

          // エラーメッセージの多言語対応
          const errorMessage =
            error.message ||
            window.i18n?.status?.failed ||
            "カートへの追加に失敗しました";

          // エラー分類
          let errorType = "error";
          if (
            error.name === "NetworkError" ||
            errorMessage.includes("network")
          ) {
            errorType = "network";
          } else if (errorMessage.includes("※")) {
            errorType = "validation";
          }

          const productType = getProductType();
          const isFootNail = productType === "foot-nail";

          // alertの代わりに新しいエラー通知システムを使用
          showUserError(errorMessage, {
            isFootNail: isFootNail,
            type: errorType,
            duration: errorType === "validation" ? 5000 : 3000,
          });
        })
        .finally(() => {
          // 処理完了
          resolve({ success: true, message: "Cart addition completed" });
        });
    } catch (error) {
      reject(error);
    }
  });
}

/**
 * Promise/async-awaitベースの重複クリック防止クラス
 */
class CartButtonController {
  constructor() {
    this.processingButtons = new Map();
  }

  /**
   * ボタンの一意IDを生成
   */
  getButtonId(button) {
    return (
      button.id ||
      button.dataset.buttonId ||
      `btn_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    );
  }

  /**
   * ボタンを処理中状態に設定
   */
  setProcessingState(button) {
    const originalState = {
      disabled: button.disabled,
      className: button.className,
      innerText: button.innerText,
      style: button.style.cssText,
    };

    button.disabled = true;
    button.classList.add("processing");
    button.style.opacity = "0.6";
    button.style.cursor = "not-allowed";
    button.innerText = window.i18n?.ui?.addingToCart || "追加中...";

    return originalState;
  }

  /**
   * ボタン状態を復元
   */
  restoreButtonState(button, originalState) {
    button.disabled = originalState.disabled;
    button.className = originalState.className;
    button.innerText = originalState.innerText;
    button.style.cssText = originalState.style;
  }
}

// グローバルインスタンス
const cartController = new CartButtonController();

// 商品ページ処理、カート追加後にページに訪れたとき
window.onload = function () {
  if (sessionStorage.getItem("from-cart-added")) {
    openCartDrawer();
    sessionStorage.removeItem("from-cart-added");
  }
};

document.addEventListener("DOMContentLoaded", () => {
  // 最近閲覧した商品を保存（商品ページの場合のみ実行）
  const productElement =
    document.querySelector("[data-product-id]") ||
    document.querySelector(".product-title");
  if (productElement && window.location.pathname.includes("/products/")) {
    // Shopifyの商品ページではmeta.product.idが利用可能
    const productIdMeta = document.querySelector(
      'meta[property="og:product:id"]'
    );
    if (productIdMeta) {
      const productId = parseInt(productIdMeta.getAttribute("content"));
      if (productId) {
        saveRecentlyViewedProduct(productId);
      }
    }
  }

  // cart-popup要素が存在する場合、cartPopupボタンのイベントリスナーを設定
  const cartPopupElement = document.getElementById("cart-popup");
  if (cartPopupElement) {
    const cartTriggers = document.querySelectorAll(".js-cart-popup-trigger");
    cartTriggers.forEach(trigger => {
      trigger.addEventListener("click", cartPopup);
    });
  }

  /**
   * カートのオプション通知ポップアップを開閉し、高さの中央に表示する
   * @param {string|number} id 通知要素の ID に使われる識別子
   */
  function optionNotice(id) {
    const popupWrap = document.querySelector(".cart-popup .popup-wrap");
    if (!popupWrap) return;

    const scrollTop = Number(popupWrap.scrollTop);
    const popupHeight = Number(popupWrap.clientHeight);
    const topPosition = scrollTop + popupHeight / 2;

    const noticeEl = document.getElementById(`notice_${id}`);
    if (!noticeEl) return;

    noticeEl.classList.toggle("open");
    noticeEl.style.top = `${topPosition}px`;
  }

  // onclick="optionNotice()"で呼び出す
  window.optionNotice = optionNotice;

  // フットネイル用の処理
  const radio = document.getElementById("tip-size-select");

  if (radio && radio.checked) {
    inputChanged({ target: radio }, "size_type");
  }

  // アドオンラベル更新の初期化
  initAddonLabelUpdates();

  // variant:changeイベントの監視
  document.addEventListener("variant:change", function (event) {
    updateAddonAvailability(event.detail.variant);
  });

  // 必須項目のチェック
  requiredCheck();
});
